import { handleCorruptToken, handleFreshToken } from '@src/state/auth/actions'
import { getLoggedIn } from '@src/state/auth/selectors'
import { getCfeUrl } from '@src/state/site/selectors'
import site from '@src/state/site/site'
import { RootState } from '@src/state/types'
import { isLocalhost } from '@src/utils/localOrPlayground'
import { Dispatch, Store } from 'redux'
import { parseJwt } from '../jwt'
import { createAxiosInstance } from './baseAxiosInstance'

export const cfeBaseUrl = getCfeUrl(site)

const legacySession = isLocalhost ? `&legacy_session=${site}` : ''

// check for differences in the response
export const NEW_TOKEN_ENDPOINT = `/api/auth/token?client=wbe${legacySession}&oneauth=true`
export const REFRESH_TOKEN_ENDPOINT = `/api/auth/refresh?client=wbe${legacySession}`
export const LOGIN_ENDPOINT = `/api/auth/login?client=wbe${legacySession}&oneauth=true`
export const PAID_STATUS_QUERY_STRING = `&refresh_paid_status=true`

export const cfeApi = createAxiosInstance(cfeBaseUrl)

export const formatRefreshUrl = (refreshPaidStatus: boolean) =>
  `${REFRESH_TOKEN_ENDPOINT}${refreshPaidStatus ? PAID_STATUS_QUERY_STRING : ''}`

let dispatch: Dispatch
let getState: () => RootState

export const setReduxHooks = (store: Store) => {
  dispatch = store.dispatch
  getState = store.getState
}

export interface TokenRequestParams {
  refreshPaidStatus?: boolean
  retry?: boolean
  fromLogout?: boolean
  fromLogin?: boolean
  fromTokenRefresh?: boolean
}

export const tokenRequest = async ({
  refreshPaidStatus = false,
  retry = false,
  fromLogout = false,
  fromLogin = false,
  fromTokenRefresh = false,
}: TokenRequestParams = {}): Promise<any> => {
  if (!dispatch || !getState) {
    return Promise.reject(
      new Error(`Cannot initiate token requests
      until \`dispatch\` has been set for cfeAuthApi.`)
    )
  }

  const wasLoggedIn = getLoggedIn(getState())
  const isRefresh = !fromLogout && (refreshPaidStatus || wasLoggedIn || fromTokenRefresh)

  try {
    const {
      data: { jwt },
    } = await cfeApi({
      url: NEW_TOKEN_ENDPOINT,
      method: 'post',
      withCredentials: true,
    })

    // check for cheggUserUuid on session refresh
    // temporary fix, shows up in wtai-bff and wfe errors as:
    // https://sentry.io/organizations/chegg/issues/1078249812/
    // and https://sentry.io/organizations/chegg/issues/1079540884/
    const parsed = parseJwt(jwt)
    if ((isRefresh || fromLogin) && !parsed.cheggUserUuid) {
      // throw to !fromLogout catch block
      throw new Error('No cheggUserUuid')
    }
    if (!fromLogin) {
      dispatch(handleFreshToken({ jwt }))
    }
    return jwt
  } catch (error) {
    if (!fromLogout) {
      dispatch(handleCorruptToken({ wasLoggedIn }))
      return Promise.reject(error)
    }
    if (retry) {
      return Promise.reject(error)
    }
    return tokenRequest({
      retry: true,
      fromLogout,
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/http-clients/cfeAuthApi.ts